import { render, staticRenderFns } from "./PidLegendNearMatch.vue?vue&type=template&id=35c45702&scoped=true&"
import script from "./PidLegendNearMatch.vue?vue&type=script&lang=js&"
export * from "./PidLegendNearMatch.vue?vue&type=script&lang=js&"
import style0 from "./PidLegendNearMatch.vue?vue&type=style&index=0&id=35c45702&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c45702",
  null
  
)

export default component.exports